import { useCallback, useEffect, useState } from "react"

import { Flex } from "antd"
import { useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"

import ExportDropdown from "../../../../../Components/Export"
import ListViewToggle from "../../../../../Components/ListViewToggle/ListViewToggle"
import ManageColumn from "../../../../../Components/ManageColumns"
import {
  selectAreFiltersDefault,
  selectCompellingEvidence,
  selectExportFetching
} from "../../redux/compelling-evidence.slice"
import { CaseDrawer } from "../CaseDrawer"
import { CASE_DRAWER_PARAM } from "../CaseDrawer/caseTexts"
import { CaseLookupList } from "../CaseLookupList"
import CaseLookupTable from "../CaseLookupTable"
import { caseColumnIconMap } from "../CaseLookupTable/columns"
import FilterBar from "../FilterBar"

const PAGE_SIZE = 20

export const CaseLookup = ({
  isMobile,
  isDemo,
  onExport,
  onChangeFilter,
  onClearFilters,
  onChangeColumns,
  onChangeViewMode,
  onGetCases
}) => {
  const [page, setPage] = useState(1)
  const [ordering, setOrdering] = useState(null)
  const [search, setSearch] = useSearchParams()

  const { fetching, result, filters, visibleFilters, columns, viewMode, selectedProgram } =
    useSelector(selectCompellingEvidence)
  const isFiltersDefault = useSelector(selectAreFiltersDefault)
  const exportFetching = useSelector(selectExportFetching)

  // react-router 6.3's setSearchParams takes no updater function (that came in 6.4), so the next
  // params are built from the current ones here; other params, like support's business account, stay.
  const handleOpenCase = useCallback(
    (id) => {
      const next = new URLSearchParams(search)
      next.set(CASE_DRAWER_PARAM, id)
      setSearch(next)
    },
    [search, setSearch]
  )

  const effectiveViewMode = isMobile ? "cards" : viewMode

  useEffect(() => {
    setPage(1)
  }, [filters, selectedProgram])

  useEffect(() => {
    const request = onGetCases({ page, ordering, page_size: PAGE_SIZE })
    return () => request.abort()
  }, [onGetCases, page, ordering])

  return (
    <>
      <FilterBar
        visibleFilters={visibleFilters}
        filters={filters}
        onChangeFilter={onChangeFilter}
        onClearFilters={onClearFilters}
        isFiltersDefault={isFiltersDefault}
        isMobile={isMobile}
        rightSlot={
          !isMobile && (
            <Flex gap={8} align="center">
              <ExportDropdown loading={exportFetching} onExport={onExport} disabled={isDemo} />
              <ManageColumn
                myColumns={columns}
                onChangeColumns={onChangeColumns}
                pinnedColumns={[]}
                iconMap={caseColumnIconMap}
              />
              <span data-testid="deflect-ce-view-toggle">
                <ListViewToggle view={viewMode} setView={onChangeViewMode} />
              </span>
            </Flex>
          )
        }
      />

      {effectiveViewMode === "cards" ? (
        <CaseLookupList
          loading={fetching}
          data={result?.results}
          totalCount={result?.count || 0}
          page={page}
          pageSize={PAGE_SIZE}
          onChangePage={setPage}
          onOpenCase={handleOpenCase}
        />
      ) : (
        <CaseLookupTable
          loading={fetching}
          data={result?.results}
          totalCount={result?.count || 0}
          page={page}
          pageSize={PAGE_SIZE}
          columns={columns}
          onChangeOrdering={setOrdering}
          onChangePage={setPage}
          onOpenCase={handleOpenCase}
        />
      )}

      <CaseDrawer />
    </>
  )
}
